import React, { useState, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import { Form, Input, Button, DatePicker, Select, Space } from 'antd';
import moment from 'moment';
import ManagerService from '../../services/ManagerService'; // Import service gọi API

const { Option } = Select;

const TaoHopDongComponent = () => {
  // State lưu danh sách khách hàng (mảng chứa { ma_khach_hang, ten_don_vi })
  const [dsKhachHang, setDsKhachHang] = useState([]);

  // Sử dụng form antd
  const [form] = Form.useForm();

  // Gọi API lấy danh sách khách hàng (từ bảng don_vi_kinh_doanh)
  useEffect(() => {
    const fetchDsKhachHang = async () => {
      try {
        const response = await ManagerService.getDonViKinhDoanh();
        if (response.success) {
          setDsKhachHang(response.data);
        }
      } catch (error) {
        console.error('Lỗi khi lấy DS khách hàng:', error);
      }
    };
    fetchDsKhachHang();
  }, []);

  // Khi người dùng chọn Mã KH, tự động cập nhật Tên đơn vị
  const handleCustomerChange = (value) => {
    const selected = dsKhachHang.find((kh) => kh.ma_khach_hang === value);
    form.setFieldsValue({
      ten_don_vi: selected ? selected.ten_don_vi : '',
    });
  };

  // Submit form
  const onFinish = async (values) => {
    try {
      // Chuyển ngày tạo thành dạng YYYY-MM-DD
      const ngay_tao = values.ngay_tao ? values.ngay_tao.format('YYYY-MM-DD') : null;

      // Tạo payload để gửi lên API
      const payload = {
        ma_hd: values.ma_hd,
        ma_khach_hang: values.ma_khach_hang,
        ten_don_vi: values.ten_don_vi,
        ngay_tao: ngay_tao,
      };

      // Gọi API tạo hợp đồng
      const response = await ManagerService.taoHopDong(payload);
      if (response.success) {
        alert('Tạo hợp đồng thành công!');
        form.resetFields();
      } else {
        alert(response.message || 'Có lỗi khi tạo hợp đồng');
      }
    } catch (error) {
      alert('Lỗi khi tạo hợp đồng: ' + error.message);
    }
  };

  return (
    <Container className="my-4">
      <h3 className="mb-4">TẠO HỢP ĐỒNG</h3>
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
      >
        {/* Mã hợp đồng */}
        <Form.Item
          label="Mã hợp đồng"
          name="ma_hd"
          rules={[{ required: true, message: 'Vui lòng nhập mã hợp đồng' }]}
        >
          <Input placeholder="Nhập mã hợp đồng" />
        </Form.Item>

        {/* Ngày tạo */}
        <Form.Item
          label="Ngày tạo"
          name="ngay_tao"
          rules={[{ required: true, message: 'Vui lòng chọn ngày tạo' }]}
        >
          <DatePicker format="YYYY-MM-DD" style={{ width: '100%' }} />
        </Form.Item>

        {/* Mã khách hàng (EVTP) */}
        <Form.Item
          label="Mã khách hàng (EVTP)"
          name="ma_khach_hang"
          rules={[{ required: true, message: 'Vui lòng chọn mã khách hàng' }]}
        >
          <Select
            showSearch
            placeholder="Chọn Mã KH"
            onChange={handleCustomerChange}
            filterOption={(input, option) => {
              const text = option.children?.toLowerCase() || '';
              return text.includes(input.toLowerCase());
            }}
          >
            {dsKhachHang.map((kh) => (
              <Option key={kh.ma_khach_hang} value={kh.ma_khach_hang}>
                {kh.ma_khach_hang}
              </Option>
            ))}
          </Select>
        </Form.Item>

        {/* Tên đơn vị */}
        <Form.Item
          label="Tên đơn vị"
          name="ten_don_vi"
        >
          <Input readOnly />
        </Form.Item>

        {/* Nút Tạo hợp đồng + Làm mới */}
        <Form.Item>
          <Space>
            <Button type="primary" htmlType="submit">
              Tạo hợp đồng
            </Button>
            <Button htmlType="button" onClick={() => form.resetFields()}>
              Làm mới
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </Container>
  );
};

export default TaoHopDongComponent;
